<template lang="pug">
    el-dialog(title="队员积分" :fullscreen="false" :close-on-click-modal='false' :visible.sync="visible" width="80%" :modal-append-to-body='false' :append-to-body="true")
        el-row
            el-col(:span="11")
                el-card(shadow="never")
                    div(slot="header")
                        el-row
                            el-col(:span='22')
                                el-input(v-model='orgName' clearable='', style='width:80%;'  placeholder="请输入姓名/级别/手机号码")
                            el-col(:span='2')
                                el-button(@click="getDataList" style='float:right;' icon='el-icon-search' ) 查询
                    div
                        el-table(:data="leftData" border v-loading='memberOrgListLoading' @selection-change="checkAll" max-height="300")
                            el-table-column(type="selection" align='center')
                            el-table-column(prop="memberName" label="姓名" align='center' width='80')
                            el-table-column(prop="memberGender" label="性别" align='center' width='80' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.memberGender === 0") 男
                                    font(v-if="scope.row.memberGender === 1") 女
                            el-table-column(prop="memberLevel" label="级别" align='center' width='80')
                            el-table-column(prop="memberMobile" label="手机号码" align='center' )
                            el-table-column(header-align='center' label='加减分' align='center'   width='180')
                                template(scope="scope")
                                    el-input-number(v-model="scope.row.memberRewardPoint",:min="-99")
                        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
            el-col(:span="2")
                div.opSetting
                    div(@click="handelSelect")
                        el-button(style='padding:10px' icon="el-icon-d-arrow-right" :disabled="nowSelectData.length ? false:true" :size="buttonSize" type="primary") 选中
                    div.spacing(@click="handleRemoveSelect")
                        el-button(style='padding:10px' icon="el-icon-d-arrow-left" :disabled="nowSelectRightData.length ? false:true" :size="buttonSize" type="danger") 取消
            el-col(:span="11")
                el-card(shadow="never")
                    div(slot="header")
                        font.font_label 已选择的人员
                    div
                        el-table(:data="rightData" border @selection-change="checkRightAll" max-height="300" )
                            el-table-column(type="selection" align='center')
                            el-table-column(prop="memberName" label="姓名" align='center' )
                            el-table-column(prop="memberGender" label="性别" align='center' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.memberGender === 0") 男
                                    font(v-if="scope.row.memberGender === 1") 女
                            el-table-column(prop="memberLevel" label="级别" align='center' )
                            el-table-column(prop="memberMobile" label="手机号码" align='center' )
                            el-table-column(prop="memberRewardPoint" label="加减分" align='center' )
        span.dialog-footer(slot="footer")
            el-button(@click="comfirmReferee" type="primary") 确 定
            el-button(@click="visible=false") 取 消
</template>
<script>
    export default{
        data(){
            return {
                visible:false,
                leftData:[],
                loading:null,
                buttonSize: 'large',
                rightData:[],  // 右边列表
                nowSelectData: [], // 左边选中列表数据
                nowSelectRightData: [], // 右边选中列表数据
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                memberOrgListLoading: false,
                orgIdList: [],
                ctId: '',
                clubId: '',
                orgName: '',
                ctList: []
            }
        },
        methods: {
            init(row){
                console.log(row)
                this.orgName = null
                this.ctId = row.ctId
                this.clubId = row.clubId
                this.leftData = []
                this.rightData = []
                this.nowSelectData = []
                this.nowSelectRightData = []

                this.visible = true
                this.$http({
                    url:this.$http.adornUrl(`/ctCompetition/grade/queryClubMemberPointList`),
                    method:'get',
                    params:this.$http.adornParams({
                        'ctId':this.ctId,
                        'clubId':this.clubId
                    })
                }).then((data)=>{
                    // if(data && data.code === 0){
                    //     for(let i of data.list){
                    //         i.ctId = row.id
                    //         i.refereeId = i.id
                    //     }
                    //     this.leftData = data.list
                    // }
                    if (data && data.code === 0) {
                        this.leftData = data.data;
                        this.rightData = [];
                        this.totalPage = data.data.length;
                    } else {
                        this.leftData = [];
                        this.totalPage = 0;
                    }
                })
            },
            getDataList() {
                this.memberOrgListLoading = true;
                this.rightData.forEach(data => {
                    this.orgIdList.push(data.id);
                });
                this.$http({
                    url: this.$http.adornUrl("/ctReferee/ctRefereeList"),
                    method: "get",
                    params: this.$http.adornParams({
                        page: this.pageIndex,
                        limit: this.pageSize,
                        name: this.orgName,
                        orgIdList: JSON.stringify(this.orgIdList)
                    })
                }).then(data => {
                    if (data && data.code === 0) {
                        this.leftData = []
                        if(data.page.records.length>0) {
                            data.page.records.forEach(e=>{
                                let x = true
                                for (let i = 0; i < this.rightData.length; i++) {
                                    if (this.rightData[i].id == e.id) {
                                        x = false
                                    }
                                }
                                if(x) {
                                    this.leftData.push(e)
                                }
                            })
                        }
                        // this.leftData = data.page.records;
                        this.totalPage = data.page.total;
                    } else {
                        this.leftData = [];
                        this.totalPage = 0;
                    }
                    this.memberOrgListLoading = false;
                });
            },
            openFullScreen() {
                this.loading  = this.$loading({
                    lock: true,
                    text: '加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            },
            comfirmReferee(){
                if(this.rightData.length === 0){
                    this.$message.success("没有需要保存的数据!")
                } else {
                    this.ctList = []
                    this.rightData.forEach(data => {
                        this.ctList.push({
                            'businessId': this.ctId,
                            'rewardPoint': data.memberRewardPoint,
                            'memberId': data.memberId
                        });
                    });
                    this.openFullScreen()
                    this.$http({
                        url:this.$http.adornUrl(`/ctCompetition/grade/club/saveMemberRewardPoints`),
                        method:'post',
                        data:this.ctList
                    }).then((data) =>{
                        if(data && data.code ===0){
                            this.visible = false
                            this.$message.success("操作成功!")
                            this.$emit('refreshDataList')
                        }else{
                            this.$message.success("操作失败!")
                        }
                        this.loading.close()
                    }).catch(() =>{
                        this.loading.close()
                    })
                }
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            checkAll(val){
                this.nowSelectData = val;
            },
            checkRightAll(val) {
                this.nowSelectRightData = val;
            },
            // 选中
            handelSelect(){
                this.rightData = this.handleConcatArr(this.rightData, this.nowSelectData)
                this.handleRemoveTabList(this.nowSelectData,  this.leftData);
                this.nowSelectData = [];
            },
            // 取消
            handleRemoveSelect() {
                this.leftData = this.handleConcatArr(this.leftData, this.nowSelectRightData)
                this.handleRemoveTabList(this.nowSelectRightData,  this.rightData);
                this.nowSelectRightData = [];
            },
            handleConcatArr(rightData, nowSelectData) {
                let arr = [];
                arr = arr.concat(rightData, nowSelectData);
                return arr;
            },
            handleRemoveTabList(isNeedArr,  originalArr) {
                if(isNeedArr.length && originalArr.length) {
                    for(let i=0; i<isNeedArr.length; i++) {
                        for(let k=0; k<originalArr.length; k++) {
                            if(isNeedArr[i]["name"] === originalArr[k]["name"]) {
                                originalArr.splice(k, 1);
                            }
                        }
                    }
                }
            },
        }
    }
</script>
